export const MODULE_NAME = 'digital-hub'
